var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pdf-page-container"},[_vm._t("default"),(_vm.currentPage < _vm.totalPages)?_c('div',{staticClass:"html2pdf__page-break"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }